function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
registerDynImportEntry('js/dispatchService', () => import('js/dispatchService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "name": {
      "displayName": "{{i18n.quoteName}}",
      "type": "STRING",
      "isRequired": false,
      "isEditable": "true",
      "dbValue": "{{data.rfqQuoteDetails.name}}",
      "dispValue": ""
    },
    "description": {
      "displayName": "{{i18n.description}}",
      "type": "STRING",
      "isRequired": false,
      "isEditable": "true",
      "dbValue": "data.rfqQuoteDetails.description",
      "dispValue": ""
    },
    "dueDate": {
      "displayName": "{{i18n.dueDate}}",
      "type": "STRING",
      "isRequired": false,
      "isEditable": "true",
      "dbValue": "data.rfqQuoteDetails.dueDate",
      "dispValue": ""
    },
    "status": {
      "displayName": "{{i18n.status}}",
      "type": "STRING",
      "isRequired": false,
      "isEditable": "true",
      "dbValue": "data.rfqQuoteDetails.status.name",
      "dispValue": ""
    }
  },
  "actions": {
    "getRfqQuoteDetails": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getRfqQuoteDetails( $collaborationspaceId: String, $rfqQuoteId: String) { getRfqQuoteDetails( collaborationspaceId: $collaborationspaceId, rfqQuoteId: $rfqQuoteId)}",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqQuoteId": "{{ctx.rfq.rfqquoteid || props.rfqquoteid}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "rfqQuoteDetails": "data.data.getRfqQuoteDetails"
      },
      "events": {
        "success": [{
          "condition": "rfqQuoteDetails.rfqQuoteId",
          "name": "get-rfq-quote-details.success",
          "eventData": {
            "rfqQuoteDetails": "{{rfqQuoteDetails}}"
          }
        }, {
          "name": "updateRfqDetailLabels",
          "condition": "rfqQuoteDetails && rfqQuoteDetails.rfqQuoteId",
          "eventData": {
            "eventName": "updateRfqDetailLabels",
            "eventData": "{{rfqQuoteDetails}}"
          }
        }, {
          "name": "enableProcessActionButtons",
          "condition": "rfqQuoteDetails && rfqQuoteDetails.status && rfqQuoteDetails.status.name",
          "eventData": {
            "eventName": "enableProcessActionButtons",
            "quoteStatus": "{{rfqQuoteDetails.status.name}}"
          }
        }, {
          "condition": "rfqQuoteDetails.error.statusCode === 400 || errorCode === 400",
          "name": "get-rfq-quote-details.error",
          "eventData": {
            "error": "{{rfqQuoteDetails.error}}",
            "errorCode": 400
          }
        }, {
          "condition": "rfqQuoteDetails.error.statusCode === 403 || errorCode === 403",
          "name": "get-rfq-quote-details.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "rfqQuoteDetails.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "get-rfq-quote-details.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "rfqQuoteDetails.error.statusCode >= 500 && rfqQuoteDetails.error.statusCode <= 599",
          "name": "get-rfq-quote-details.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "get-rfq-quote-details.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "updateRfqDetailLabelsAction": {
      "actionType": "JSFunction",
      "method": "updateRfqQuoteDetailLabelsFunction",
      "inputData": {
        "data": "{{data}}",
        "jobDetails": "{{parameters.eventData}}"
      },
      "deps": "js/dispatchService"
    }
  },
  "onEvent": [{
    "eventId": "updateRfqDetailLabels",
    "action": "updateRfqDetailLabelsAction",
    "inputArgs": {
      "eventName": "{{eventData.eventName}}",
      "eventData": "{{eventData.eventData}}"
    }
  }, {
    "eventId": "updateRfqQuoteDetailLabelsConsolidateView",
    "action": "getRfqQuoteDetails",
    "inputArgs": {
      "eventName": "{{eventData.eventName}}",
      "eventData": "{{eventData.eventData}}"
    }
  }, {
    "eventId": "process-rfq-quote.success",
    "action": "getRfqQuoteDetails",
    "inputArgs": {
      "eventName": "{{eventData.eventName}}",
      "eventData": "{{eventData.eventData}}"
    }
  }, {
    "eventId": "submit-rfq-quote.success",
    "action": "getRfqQuoteDetails",
    "inputArgs": {
      "eventName": "{{eventData.eventName}}",
      "eventData": "{{eventData.eventData}}"
    }
  }, {
    "eventId": "get-rfq-quote-details.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-get-rfq-quote-details.success",
      "eventData": "{{eventData.rfqQuoteDetails}}"
    }
  }, {
    "eventId": "get-rfq-quote-details.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-get-rfq-quote-details.error",
      "eventData": "{{eventData.error}}"
    }
  }, {
    "eventId": "submit-rfq-quote.success",
    "action": "getRfqQuoteDetails",
    "cacheEventData": true
  }, {
    "eventId": "process-rfq-quote.success",
    "action": "getRfqQuoteDetails",
    "cacheEventData": true
  }],
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqid": {
      "type": "string"
    }
  },
  "lifecycleHooks": {
    "onInit": "getRfqQuoteDetails"
  },
  "i18n": {
    "name": ["RfqMessages"],
    "dueDate": ["RfqMessages"],
    "description": ["RfqMessages"],
    "status": ["RfqMessages"],
    "quoteName": ["RfqMessages"],
    "rfqQuoteDetails": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_CREATE_RFQ": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "_viewModelId": "GetRfqQuoteDetails",
  "_uniqueViewModelId": "GetRfqQuoteDetails",
  "ctx": {
    "rfq": {
      "type": "object"
    }
  }
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <aw-panel>
        <aw-panel-body>
            <table>
                <tr>
                    <td class="displayInlineFlex">
                        <aw-label prop="data.name" class="rfqHeader label-without-property"></aw-label>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td><aw-label prop="data.description" class="alignLeft label-without-property"></aw-label></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <h4>
                        <td class="rfqDetailsWidth"><aw-label prop="data.dueDate" class="propertyDisplay"></aw-label></td>
                    </h4>
                    <h4>
                        <td class="rfqDetailsWidth"><aw-label prop="data.status" class="propertyDisplay"></aw-label></td>
                    </h4>
                    <td></td>
                </tr>
            </table>
        </aw-panel-body>
    </aw-panel>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal
  }, /*#__PURE__*/React.createElement(AwPanelBody, null, /*#__PURE__*/React.createElement("h4", null), /*#__PURE__*/React.createElement("h4", null), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "displayInlineFlex"
  }, /*#__PURE__*/React.createElement(AwLabel, _extends({}, getField("data.name", fields, $index, null, null), {
    className: "rfqHeader label-without-property"
  }))), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwLabel, _extends({}, getField("data.description", fields, $index, null, null), {
    className: "alignLeft label-without-property"
  }))), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "rfqDetailsWidth"
  }, /*#__PURE__*/React.createElement(AwLabel, _extends({}, getField("data.dueDate", fields, $index, null, null), {
    className: "propertyDisplay"
  }))), /*#__PURE__*/React.createElement("td", {
    className: "rfqDetailsWidth"
  }, /*#__PURE__*/React.createElement(AwLabel, _extends({}, getField("data.status", fields, $index, null, null), {
    className: "propertyDisplay"
  }))), /*#__PURE__*/React.createElement("td", null)))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;